import { useSessionStore } from '@/stores/session';

const UTC_TIME_ZONE = 'UTC';
/** Часовой пояс организации по умолчанию (CompanySettingsService) */
const DEFAULT_TIME_ZONE = UTC_TIME_ZONE;

/** Пояс организации из состояния сессии; пока он неизвестен — UTC */
export const sessionTimeZone = (state: ReturnType<typeof useSessionStore.getState>): string =>
	state.user?.company_timezone ?? DEFAULT_TIME_ZONE;

/**
 * Часовой пояс организации вне компонентов — для выгрузок и обработчиков, где хук недоступен.
 * Читает сессию в момент вызова, поэтому смена пояса не требует перезагрузки.
 */
export function organizationTimeZone(): string {
	return sessionTimeZone(useSessionStore.getState());
}
